import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

export let bsConfig: any = {
    locale: 'pl',
    dateInputFormat: 'D.MM.YYYY',
    containerClass: 'theme-brand',
    showWeekNumbers: false,
    selectFromOtherMonth: true,
    customTodayClass: 'today-highlight',
};
